module.exports = __webpack_public_path__ + "static/media/en_how-it-work.f7859452.png";